import React, { useContext, useEffect, useState } from 'react'
import { ApiContext } from '../context/ApiContext';
import { PodcastAllOptionsContext } from '../context/PodcastAllOptionsContext';
import { getAppData } from '../apiService';
import { NavbarContext } from '../context/NavbarContext';
import { useNavigate } from 'react-router-dom';
import { FiDownload } from "react-icons/fi";
import { BiSliderAlt } from "react-icons/bi";
import { MdOutlinePlayCircleOutline } from "react-icons/md";
import AudioPlayer2 from './AudioPlayer2';
import { ShimmerCircularImage, ShimmerContentBlock, ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects';

function Interviews() {
  const { Categories3, Categories3_id, setCategories3_id, setAudioSrc555, interviewsisPlaying, interviewsaudioRef, interviewstogglePlayPause, isPlayingOrNot, togglePlayPause5, isPlayings } = useContext(ApiContext);
  const navigate = useNavigate();
  const { navHeading, setNavHeading } = useContext(NavbarContext)
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null);
  const [error, setError] = useState(null);
  const [episodes1, setEpisodes1] = useState(null);
  const { singlePodcastId, setSinglePodcastId } = useContext(PodcastAllOptionsContext)
  // useEffect(() => {
  //     const podcast = SportsAllValue.find(item => item.id === singlePodcastId);
  //     const podcastName = podcast ? podcast.name : episodes1 ? episodes1.title : null;

  //     // console.log(podcastName);

  //     setNavHeading(podcastName)
  //   }, [singlePodcastId])
  useEffect(() => {
    if (Categories3) {
      setEpisodes1(Categories3[0]);
    }
  }, [Categories3])
  useEffect(() => {
    if (episodes1 && episodes1.id) {
      if (episodes1.id === id) {
        const heading = episodes1.title.length > 55 ? episodes1.title.substring(0, 57) + '...' : episodes1.title;
        setNavHeading(heading);
        // console.log(episodes1, "now i have set here");

        setAudioSrc555(episodes1.file);
        if (interviewsisPlaying) {
          if (interviewsaudioRef.current) {
            const audio = interviewsaudioRef.current
            audio.oncanplaythrough = () => {
              audio.play();
            }
          }
        } else if (!interviewsisPlaying) {
          interviewstogglePlayPause();
        }
      }
    }
  }, [episodes1, id]);

  // this feature is to play interview
  // useEffect(() => {
  //   if (interviewsisPlaying) {
  //     if ( interviewsaudioRef.current) {
  //       interviewsaudioRef.current.play().catch((error) => console.error("Play error:", error));
  //       if (isPlayingOrNot) {
  //         togglePlayPause5()
  //       }
  //       if( isPlayings){
  //         interviewstogglePlayPause()
  //         // setinterviewsisPlaying(prev=>!prev)
  //       }
  //     }
  //   } else {
  //     if (interviewsaudioRef.current) {
  //       interviewsaudioRef.current.pause();
  //     }
  //     // if (isPlayingOrNot) {
  //     //   togglePlayPause()
  //     // }
  //   }
  // }, [isPlayings, interviewsaudioRef, isPlayingOrNot,interviewsisPlaying]);


  useEffect(() => {
    // if (episodes) {
    //   // console.log(episodes, "here are episodes");
    //   setAudioSrc(episodes[0]["enclosure"]["@_url"])
    //   const heading = episodes[0]["itunes:title"].length > 55 ? episodes[0]["itunes:title"].substring(0, 57) + '...' : episodes[0]["itunes:title"];
    //   setNavHeading(heading)
    // } 
    // else

    if (episodes1) {
      // console.log(episodes1, "here are episodes1");
      const heading = episodes1.title.length > 55 ? episodes1.title.substring(0, 57) + '...' : episodes1.title;
      setNavHeading(heading)
      setAudioSrc555(episodes1.file)
      //   setAudioSrc(episodes1.file)
    }
  }, [episodes1]);
  //   useEffect(()=>{
  //     if(Categories3){
  //   setLoading(true)
  //     }
  //   },[Categories3])


  if (!episodes1) {
    return (
      <>
        <div className='layout10-div'>
          <div className='interviews-internal-main-new'>
            <div className='interviews-internal-left-main'>
              <div className='interview-main-playing-image'>
                <ShimmerThumbnail height={450} rounded />
              </div>
              <div className='audio-player '>
                <div className='flex justify-center mb-4'><ShimmerCircularImage size={55} /></div>
                <div className='flex justify-around items-center'>
                  <ShimmerCircularImage size={35} />
                  <ShimmerCircularImage size={35} />
                  <ShimmerCircularImage size={35} />
                  <ShimmerCircularImage size={35} />
                </div>
                <hr className='My-audio-payer-hr' />
                <div>
                  <ShimmerText line={1} gap={5} />
                </div>

              </div>
            </div>
            <div className='interviews-internal-ringht-main'>
              <p className='interview-internal-para-episode'>Interviews</p>
              <div className='interview-internal-all-single-podcasts'>
                <div className='interview-main-single-outer-div'>
                  <ShimmerContentBlock
                    title
                    text
                    cta
                    thumbnailWidth={170}
                    thumbnailHeight={170}
                    style={{ marginBottom: "10px" }}
                  />
                </div>

                <div className='interview-main-single-outer-div'>
                  <ShimmerContentBlock
                    title
                    text
                    cta
                    thumbnailWidth={170}
                    thumbnailHeight={170}
                    style={{ marginBottom: "10px" }}
                  />
                </div>

                <div className='interview-main-single-outer-div'>
                  <ShimmerContentBlock
                    title
                    text
                    cta
                    thumbnailWidth={170}
                    thumbnailHeight={170}
                    style={{ marginBottom: "10px" }}
                  />
                </div>

              </div>
            </div>

          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }
  const handleRecentPodcast22 = (id1) => {
    // console.log("I am setting id ",id1);

    if (id == id1) {
      if (interviewsaudioRef.current) {
        const audio = interviewsaudioRef.current;
        audio.currentTime = 0;  // Reset audio to the start
        audio.play();  // Play the audio from the beginning
      }
    } else {
      setEpisodes1(Categories3.find((item) => item.id == id1))
      setId(id1)
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });

    //   const fetchFeed = async () => {

    //     try {
    //       const result2 = await getAppData(`/api.php?set=SingleInterview&id=${id1}`)
    //       if (result2.success == 1) {
    //         // console.log(result2.data.result, "categs");
    //         setEpisodes1(result2.data.result);
    //         // console.log(result2.data.result,"data hun aya");

    // // if(episodes1.id == id){
    // //   const heading = episodes1.title.length > 55 ? episodes1.title.substring(0, 57) + '...' : episodes1.title;
    // //   setNavHeading(heading)
    // //   console.log(episodes1,"hun set hoya ha");

    // //   setAudioSrc555(episodes1.file)
    // //   if (interviewsisPlaying && interviewsaudioRef.current) {
    // //     interviewsaudioRef.current.play();

    // //   }else if(!interviewsisPlaying){    
    // //     interviewstogglePlayPause();
    // //   }
    // // }
    //   // setNavHeading(episodes1.title)
    //       }
    //     } catch (err) {
    //       setError('Error fetching data. Please try again later.');
    //       console.error('Error:', err);
    //     } finally {
    //         setLoading(false);
    //         window.scrollTo({ top: 0, behavior: 'smooth' });

    //     }
    //   }

    //   fetchFeed();



    // setCategories3_id(id) 
    // navigate(`/player`)
  }


  return (
    <div className='layout10-div'>

      {/* <div className='podcast-second-recent-pd1'>
                <p className='podcast-heading21'>single Podcasts</p>
                <div className='all-recent-podcast-div21'>
                    {Categories3.map((item)=>(
                        <div className='single-recent-podcast-div21-image' key={item.id} onClick={()=>handleRecentPodcast22(item.id)}>
                        <img src={item.image} alt={item.title} style={{width:"100%",height:"100%"}}/>
                        </div>
                    ))}
                </div>
                </div>


                <div className='podcast-second-recent-pd1'>
                <p className='podcast-heading21'>single Podcasts</p>
                <div className='all-recent-podcast-div21'>
                    {Categories3.map((item)=>(
                        <div className='single-recent-podcast-div21-image' key={item.id} onClick={()=>handleRecentPodcast22(item.id,item)}>
                            // {console.log(Categories,"Catttttttttttttttttttttttt")} 
                        <img src={item.image} alt={item.title} style={{width:"100%",height:"100%"}}/>
                        </div>
                    // ))}
                </div>
                </div>
                
                
                */}


      <div className='interviews-internal-main-new'>
        {<div className='interviews-internal-left-main'>
          <div className='interview-main-playing-image'>
            {/* {console.log(toPlay,"tooplay")} */}

            <img src={episodes1.image} alt={episodes1.title} width={"100%"} height={"100%"} />
          </div>
          <AudioPlayer2 />
          {/* <div></div>                    player     song will come from episodes1 */}
        </div>}
        <div className='interviews-internal-ringht-main'>
          <p className='interview-internal-para-episode'>Interviews</p>
          <div className='interview-internal-all-single-podcasts'>

            {Categories3.map((item) => (
              <div className='interview-main-single-outer-div' key={item.id} onClick={() => { handleRecentPodcast22(item.id); }}>
                {/* {console.log(Categories3,"category3")} */}

                <div className='interview-main-single-inner-div-with-image-and-text'>
                  <div className='interview-main-image-div-single'>
                    <img src={item.image} alt={item.title} width={"100%"} height={"100%"} />
                  </div>
                  <div className='interview-main-paras-div-single'>
                    <p className='interview-main-para1-p'>{item.title}</p>
                    {/* <p className='interview-main-para2-p'>text2</p> */}
                    <div className='interview-all-options-icons-only-for-dasktop-and-laptop'>
                      <MdOutlinePlayCircleOutline />
                      <FiDownload />
                      <BiSliderAlt />
                    </div>
                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>
      </div>

    </div>
  )
}

export default Interviews